// extracted by mini-css-extract-plugin
module.exports = {"loading":"EditTicketEvent_loading__2VShp"};